
import React, { useState } from "react";
import { SubscriptionDebugInfo } from "./SubscriptionDebugInfo";
import { SubscriptionList } from "./SubscriptionList";
import { useSubscriptionData } from "@/hooks/useSubscriptionData";
import { UserContent } from "./UserContent";
import { AdminPanel } from "./AdminPanel";
import { SupabaseStatusCheck } from "./SupabaseStatusCheck";

interface SubscriptionContainerProps {
  showHeading?: boolean;
}

export function SubscriptionContainer({ showHeading = true }: SubscriptionContainerProps) {
  const [supabaseStatus, setSupabaseStatus] = useState<string>("Checking...");

  const {
    subscriptions,
    isLoading,
    error,
    isError,
    createSubscription,
    isCreating,
    processPayments,
    isProcessingPayments,
    exportSubscriptions,
    isExporting
  } = useSubscriptionData();
  
  return (
    <div className="w-full" data-testid="subscription-manager">
      <SupabaseStatusCheck setSupabaseStatus={setSupabaseStatus} />
      
      <SubscriptionDebugInfo
        showHeading={showHeading}
        supabaseStatus={supabaseStatus}
        isLoading={isLoading}
        isError={isError}
        error={error}
        subscriptions={subscriptions}
      />
      
      {showHeading && <h1 className="text-3xl font-bold mb-6">Bin Wash Subscriptions</h1>}
      
      <UserContent 
        onSubmit={createSubscription}
        isLoading={isCreating}
      />

      <AdminPanel
        onProcessPayments={processPayments}
        onExport={exportSubscriptions}
        isProcessingPayments={isProcessingPayments}
        isExporting={isExporting}
      />

      <SubscriptionList
        isLoading={isLoading}
        isError={isError}
        error={error}
        subscriptions={subscriptions}
      />
    </div>
  );
}
